// @file Tldraw asset store
import { FRAME_PREVIEW_SCALE } from '@@/bits/whiteboard_preview_utils'
import { processedUrl } from '@padlet/vivaldi-client'
import type { TLAssetStore } from '@tldraw/editor'

const assetStore: TLAssetStore = {
  async upload() {
    // We handle assets using our native padlet attachments instead of what tldraw uses
    // so the `upload` method is a no-op.
    return ''
  },
  resolve(asset, { screenScale, dpr, shouldResolveToOriginal }) {
    // Only resolve image assets created by us. Ignore the rest.
    if (asset.type !== 'image' || asset.props.src == null || asset.meta.source !== 'padlet-attachment-shape') {
      return null
    }

    // Tldraw sets this to true when it needs the original asset e.g. for exporting.
    // ~~We should respect that~~ ❌. NOPE, we should still return a processed version
    // of the asset because our only use case of exporting now is to generate the
    // frame previews. If we resolve to the original asset, the asset being too big
    // will cause the frame preview generation to be slow/fail.
    if (shouldResolveToOriginal) {
      // Tldraw has an internal logic to convert external images to data URI before exporting.
      // https://github.com/tldraw/tldraw/blob/main/packages/tldraw/src/lib/shapes/image/ImageShapeUtil.tsx#L133-L141
      // This makes the export payload super huge and can't be handled by the backend.
      // To opt out of this behavior, we'll add a custom protocol to the exported URL
      // and will revert it in the backend before generating the frame preview.
      // @see serverless/workers/svg-png/src/image_handler.ts
      return (
        'padlet://' +
        processedUrl(asset.props.src, {
          width: asset.props.w * FRAME_PREVIEW_SCALE(),
          dpr,
          format: 'png', // Our SVG to PNG worker fails to process anything other than PNG.
          // Even if this is a base64 image embedded in an SVG, its data still has to be
          // stored in a PNG format.
        })
      )
    }

    return processedUrl(asset.props.src, {
      width: asset.props.w * screenScale,
      dpr,
    })
  },
}

export { assetStore }
